// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import get from 'lodash/get';

const styles = ({ fontSize }) => ({
  marginPanelContainer: {
    minHeight: '800px',
    padding: '0 36px',
  },
  detailsContainer: {
    padding: '20px 36px',
  },
  paper: {
    paddingRight: '20px',
    marginTop: '20px',
  },
  hideFooterContainer: {
    display: 'none',
  },
  showFooterContainer: {
    display: 'visible',
  },
  title: {
    fontSize: `${get(fontSize, 'smallTitle')} !important`,
    marginTop: 0,
  },
  eulaFieldContainer : {
    '& .MuiInputBase-root.Mui-disabled' : {
      backgroundColor : 'rgba(0,0,0,0.1)',
      borderColor : 'black',
    },
    '& .MuiSvgIcon-root.MuiSelect-icon.Mui-disabled' : {
      visibility : 'hidden',
    },
  },
});

export default styles;
